{
  "deprecatedBrowser": "Seu navegador não é compatível",
  "deprecatedBrowserHelpText": "Considere atualizar seu navegador para a versão mais recente para garantir a melhor experiência."
}
